import * as React from 'react'

export default function useKeyboardEvent(
  key: string | number,
  callback: (event: KeyboardEvent) => void,
) {
  React.useEffect(() => {
    const handler = function (event: KeyboardEvent) {
      if (event.key === key || event.keyCode === key) {
        callback(event)
        event.stopPropagation()
        event.preventDefault()
      }
    }
    window.addEventListener('keydown', handler)
    return () => {
      window.removeEventListener('keydown', handler)
    }
  }, [key, callback])
}
